import React from "react";
import styled from "styled-components";

const PulsingDot = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  height: 10rem;
  width: 10rem;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6rem;
    height: 6rem;
    margin-top: -3rem;
    margin-left: -3rem;
    border-radius: 50%;
    border: 6px solid var(--theme-active-indicator);
    animation: pulse 0.3s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(0);
      opacity: 0.1;
    }
    40% {
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
`;

class WeekData extends React.Component {
  render() {
    if (!this.props.show) return null;
    return (
      <PulsingDot show={this.props.show}>
        <div />
      </PulsingDot>
    );
  }
}

export default WeekData;
